import Component from '../classes/Component';
import {$dom} from '../helpers/dom';
import is from 'is_js';
import {forIn, generateId, warn} from '../helpers/_utilities';
import {$events} from "../helpers/events";
import variables from "../variables";
import {$style} from "../helpers/style";

const {get, getAll, exist, callAll} = $dom;
const {dom} = variables;

const modalSelector = '.js-modal';
const modalHashAttr = 'data-hash-name';
const closeOnEscAttr = 'data-close-on-esc';

export default function modal() {

    const $Page = this;

    const createModal = modalEl => {
        modalEl.modalId = $dom.attr(modalEl, 'id') || generateId();

        return {instance: $Page.bootstrap.Modal.getOrCreateInstance(modalEl), id: modalEl.modalId}
    };

    return new Component({
        name: 'modal',
        requiredTargets: 'STAND_ALONE',
        onCreate() {
            this.modals = {};
        },
        onInit() {
            this.modalIsCashed = id => this.modals.hasOwnProperty(id);

            this.checkElementExist = (id, cb = null) => {
                if (exist('#'+id)) {
                    if (is.function(cb)) {
                        cb(get('#'+id))
                    }
                } else {
                    warn(`Modal element by id "${id}" is not found`, 'Modal Component')
                }
            };

            this.open = id => {
                this.checkElementExist(id, elem => {
                    if (this.modalIsCashed(elem.modalId)) {
                        this.modals[elem.modalId].show()
                    } else {
                        const {instance,id} = createModal(elem);

                        this.modals[id] = instance;

                        this.modals[id].show()
                    }
                })
            };

            this.close = (id = null) => {
                if (is.null(id)) {
                    forIn(this.modals, (_, modal) => modal.hide())
                } else {
                    this.checkElementExist(id, elem => {
                        if (this.modalIsCashed(elem.modalId)) {
                            this.modals[elem.modalId].hide()
                        } else {
                            const {instance,id} = createModal(elem);

                            this.modals[id] = instance;

                            this.modals[id].hide()
                        }
                    })
                }
            };

            const scrollbarWidth = variables.scrollbarWidth;

            this.headerIsFixed = () => $style.get(dom.header, 'position') === 'fixed';

            this.handleModalShow = () => {
                if (this.headerIsFixed())
                    dom.header.style.paddingRight = scrollbarWidth+'px';
            };

            this.handleHashModalShow = ({target}) => {
                window.location.hash = $dom.attr(target, modalHashAttr);
            };

            this.handleModalHidden = () => {
                if (this.headerIsFixed())
                    dom.header.style.paddingRight = '';
            }

            this.handleHashModalHidden = () => {
                if (window.history.replaceState) {
                    window.history.replaceState(null, null, ' ');
                } else {
                    window.location.hash = '';
                }
            };

            this.handleDocumentKeyDown = e => {
                if (e.key === 'Escape') {
                    const activeModal = getAll(modalSelector)
                        .find(m => m.getAttribute('aria-hidden') !== 'true');

                    (activeModal && activeModal.getAttribute(closeOnEscAttr) !== 'false') && this.close()
                }
            };

            if (exist(modalSelector)) {
                callAll(modalSelector, modalEl => {
                    const {instance,id} = createModal(modalEl);
                    this.modals[id] = instance;

                    const hashAttr = $dom.attr(modalEl, modalHashAttr);

                    if (hashAttr && hashAttr === window.location.hash.replace('#', ''))
                        instance.show()
                });
            }


            $events.delegate
                .on('keydown', document, this.handleDocumentKeyDown)

                .on('show.bs.modal', modalSelector, this.handleModalShow)
                .on('show.bs.modal', `[${modalHashAttr}]`, this.handleHashModalShow)
                .on('hidden.bs.modal', modalSelector, this.handleModalHidden)
                .on('hidden.bs.modal', `[${modalHashAttr}]`, this.handleHashModalHidden)

        },
        onDestroy() {
            $events.delegate
                .off('keydown', document, this.handleDocumentKeyDown)

                .off('show.bs.modal', modalSelector, this.handleModalShow)
                .off('show.bs.modal', `[${modalHashAttr}]`, this.handleHashModalShow)
                .off('hidden.bs.modal', modalSelector, this.handleModalHidden)
                .off('hidden.bs.modal', `[${modalHashAttr}]`, this.handleHashModalHidden)

            this.close();
            this.modals = {};

            this.open = Function.prototype;
            this.close = Function.prototype;
        },
    })
}
